import { render, staticRenderFns } from "./goodsActivity.vue?vue&type=template&id=1219841d&scoped=true"
import script from "./goodsActivity.vue?vue&type=script&lang=js"
export * from "./goodsActivity.vue?vue&type=script&lang=js"
import style0 from "./goodsActivity.vue?vue&type=style&index=0&id=1219841d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1219841d",
  null
  
)

export default component.exports